import { InputChangeEventDetail, TextareaInputChangeEventDetail } from '@wppopen/components-library'
import { WppTextareaInput, WppTypography } from '@wppopen/components-library-react'
import { WppInputCustomEvent, WppTextareaInputCustomEvent } from '@wppopen/components-library/dist/types/components'
import { Dispatch, Fragment, SetStateAction, useContext, useMemo } from 'react'
import { TypographyProps } from '../TextContainer.d'
import {
  getKeywordsFromReducer,
  parseStringToJSX,
} from 'components/KeywordsElements/Highlighting/HighlightedTextBodySpan/utils'
import ViewTaskPageContext from 'context/viewTaskPageContext/viewTaskPageContext'

interface TextContainerListProps {
  title: string
  textContent: string
  setTextContent: Dispatch<SetStateAction<string>>
  isEditModeEnabled: boolean
}

function TextContainerParagraph({ title, textContent, setTextContent, isEditModeEnabled }: TextContainerListProps) {
  const handleInputChange = (
    event: WppInputCustomEvent<InputChangeEventDetail> | WppTextareaInputCustomEvent<TextareaInputChangeEventDetail>,
  ) => {
    event.preventDefault()
    const { target } = event
    setTextContent(target.value)
  }

  const { shouldShowKeywords, keywordsAndPhrasesReducerstate } = useContext(ViewTaskPageContext)

  const paragraphs = textContent.split(/\n\r/).filter(text => !!text)

  const typographyProps: TypographyProps = {
    type: title.toLowerCase() === 'title' ? 'xl-heading' : 's-body',
    tag: title === 'title' ? 'h2' : 'p',
  }

  const reducerKeywordsList = useMemo(() => {
    return getKeywordsFromReducer(keywordsAndPhrasesReducerstate)
  }, [keywordsAndPhrasesReducerstate])

  return isEditModeEnabled ? (
    <>
      <WppTextareaInput
        size="m"
        role="textbox"
        value={paragraphs.join('\n')}
        onWppChange={e => handleInputChange(e)}
        data-testid="edit-product-text--textarea"
      />
    </>
  ) : (
    <>
      {paragraphs.map(paragraph => (
        <Fragment key={paragraph}>
          <WppTypography {...typographyProps} data-testid="product-text">
            {shouldShowKeywords
              ? parseStringToJSX(paragraph, reducerKeywordsList, keywordsAndPhrasesReducerstate.activeKeyword)
              : paragraph}
          </WppTypography>
        </Fragment>
      ))}
    </>
  )
}

export default TextContainerParagraph
